import {Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import {
  Application,
  RunCreditFlowFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  GetCreditAuditLogFn,
  GetApplicationByIdFn,
  GetDuplicatedApplicationsFn,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  GetUserFn,
  RequestMoreInformationFn,
  isAdminOrCreditUser,
  User,
  RemoveApplicationNoteByNoteIdFn,
  CreateApplicationNoteFn,
  GetApplicationDscrFn,
  NewWebService
} from '@portal-workspace/grow-shared-library';
import {
  GetApplicationAuditLogsFn,
  GetNotesByApplicationIdFn,
  getUser,
  setupUntilDestroy,
} from '@portal-workspace/grow-ui-library';
import { LvrCalculatorComponent } from '../lvr-calculator.component';
import {
  isInternalUser,
} from '@portal-workspace/grow-shared-library';
import { UntypedFormBuilder} from '@angular/forms';
 
 
import { Subscription} from 'rxjs';
import {UntilDestroy} from '@ngneat/until-destroy';
import {PortalHotToastService} from '../../portal-hot-toast-component/hot-toast.service';
import {ApplicationDialogService} from '../../application-dialog-component/application-dialog.service';
import { MatExpansionModule } from "@angular/material/expansion";
import { CreditOverviewComponent } from '../../credit-component/credit-overview.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { NgTemplateOutlet } from '@angular/common';
@UntilDestroy({arrayName: 'subscriptions'})
@Component({
    selector: 'corporate-loans-credit',
    templateUrl: './corporate-loans-credit.component.html',
    styleUrls: ['./corporate-loans-credit.component.scss'],
    standalone: true,
    imports: [MatExpansionModule,LvrCalculatorComponent,CreditOverviewComponent, MatTabsModule, MatCardModule, NgTemplateOutlet]
})

export class CorporateLoansCreditComponent implements OnInit {
 
  subscriptions: Subscription[] = [];
  expandedIndex = 1;
  
  @Input() application!: Application;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Output() viewReport: EventEmitter<NewWebService> = new EventEmitter();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  isInternalUser = isInternalUser;
  isAdminOrCreditUser = isAdminOrCreditUser;
  loggedInUser: User | null = getUser();

  constructor(private formBuilder: UntypedFormBuilder,
              private toastService: PortalHotToastService,
              private dialogService: ApplicationDialogService,
              ) {
  
  }
  
  isPanelExpanded(index: number): boolean {
    return this.expandedIndex === index;
  }
  expandPanel(index: number) {
    this.expandedIndex = index;
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
  }

  onViewReport(element: NewWebService) {
    this.viewReport.emit(element)
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
